import { store } from "../store/index";
import {
  filterLocation,
  removeLocation,
  modifyLocation,
  getLocationByUuid,
  createLocation,
  getAll,
} from "../store/actions/LocationActions";

/**
 * Create Location
 */
export const addLocation = async (values) => {
  const objSend = { ...values };
  const result = await store.dispatch(createLocation(objSend));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * Get Location
 */
export const getLocation = async (uuid) => {
  const param = [uuid];
  const result = await store.dispatch(getLocationByUuid(param));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Update Location
 */
export const updateLocation = async (values, uuid) => {
  const objSend = { ...values };
  const result = await store.dispatch(modifyLocation(objSend, [uuid]));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * List Location
 */
export const listFilter = async (filter) => {
  const result = await store.dispatch(filterLocation(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Delete Location
 */
export const deleteLocation = async (uuid) => {
  const result = await store.dispatch(removeLocation([uuid]));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Get all locations
 */
export const getAllLocations = async (filters = {}) => {
  const result = await store.dispatch(getAll(filters));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};
